import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../constants/common'
import i18n from '../../../i18n'

import {
  ATTACH_SERVICE_REQUESTS_CLOSED_STATUSES,
  ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME,
  ATTACH_SERVICE_REQUESTS_NOTIFICATION_ID,
  AttachServiceRequestsStatusAction,
} from './AttachServiceRequestsModal.constants'

export function getAttachServiceRequestsModalTableColumns() {
  return {
    [ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.assignees]: {
      index: 7,
      name: ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.assignees,
      ordering_field: null,
      title: 'Modal.AttachServiceRequestsColumnAssigneesKey',
      visible: true,
      width: 240,
    },
    [ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.building]: {
      index: 2,
      name: ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.building,
      ordering_field: 'building_title',
      title: 'Modal.AttachServiceRequestsColumnBuildingKey',
      visible: true,
      width: 416,
    },
    [ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.deadline]: {
      index: 5,
      name: ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.deadline,
      ordering_field: 'due_date',
      title: 'Modal.AttachServiceRequestsColumnDeadlineKey',
      visible: true,
      width: 192,
    },
    [ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.flat]: {
      index: 3,
      name: ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.flat,
      ordering_field: 'flat_number',
      title: 'Modal.AttachServiceRequestsColumnFlatKey',
      visible: true,
      width: 152,
    },
    [ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.manager]: {
      index: 6,
      name: ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.manager,
      ordering_field: 'owner_fullname',
      title: 'Modal.AttachServiceRequestsColumnManagerKey',
      visible: true,
      width: 240,
    },
    [ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.requestNo]: {
      index: 0,
      name: ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.requestNo,
      ordering_field: 'id',
      title: 'Modal.AttachServiceRequestsColumnRequestNumberKey',
      visible: true,
      width: 150,
    },
    [ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.status]: {
      index: 4,
      name: ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.status,
      ordering_field: 'status',
      title: 'Modal.AttachServiceRequestsColumnStatusKey',
      visible: true,
      width: 176,
    },
    [ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.title]: {
      index: 1,
      name: ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.title,
      ordering_field: 'title',
      title: 'Modal.AttachServiceRequestsColumnTitleKey',
      visible: true,
      width: 448,
    },
  }
}

export function getAttachServiceRequestsFromResponse(data) {
  return { items: data.items }
}

export function getAttachServiceRequestsInitialNotifications({
  canSelectOnlyOneNotificationKey = 'Modal.AttachServiceRequestsModalNotificationCanSelectOnlyOneKey',
  multipleSelection,
  readonly,
  showLimitNotification,
  t,
}) {
  if (readonly) {
    return EMPTY_LIST
  }

  if (multipleSelection) {
    return showLimitNotification
      ? [
          {
            id: ATTACH_SERVICE_REQUESTS_NOTIFICATION_ID.limitInfo,
            text: t('Modal.AttachServiceRequestsModalNotificationLimitInfoKey'),
            type: NOTIFICATION_TYPE.info,
          },
        ]
      : EMPTY_LIST
  }

  return [
    {
      id: ATTACH_SERVICE_REQUESTS_NOTIFICATION_ID.canSelectOneItem,
      text: t(canSelectOnlyOneNotificationKey),
      type: NOTIFICATION_TYPE.info,
    },
  ]
}

export function getAttachServiceRequestsEditStatusInitialNotifications() {
  return [
    {
      text: i18n.t(
        'Modal.AttachServiceRequestsChangeStatusModalNotificationKey'
      ),
      type: NOTIFICATION_TYPE.info,
    },
  ]
}

export function getAttachServiceRequestsStatusAction({
  changeStatusAttention,
  item,
  restoreAttention,
}) {
  if (restoreAttention && item.archived) {
    return AttachServiceRequestsStatusAction.Restore
  }

  if (
    changeStatusAttention &&
    ATTACH_SERVICE_REQUESTS_CLOSED_STATUSES.includes(item.status)
  ) {
    return AttachServiceRequestsStatusAction.ChangeStatus
  }

  return null
}

export function isEqualAttachServiceRequestModal({
  allowEmptySelection,
  selected,
}) {
  return !allowEmptySelection && selected.length === 0
}

export function getRelatedRequestsLimitErrorMeta(error) {
  const meta = error?.response?.data?.meta

  if (meta?.max_size != null && meta?.current_size != null) {
    return { count: meta.current_size, limit: meta.max_size }
  }

  return null
}
